import { createFileRoute } from "@tanstack/react-router";

import { MCP_CLIENTS } from "@/components/Mcp/mcpClients";
import { mcpHubHead } from "@/components/Mcp/mcpHead";
import { HUB_FAQS } from "@/components/Mcp/mcpHubFaqs";
import { McpHubPage } from "@/components/Mcp/McpHubPage";

export const Route = createFileRoute("/mcp/")({
  component: McpHubPage,
  head: () =>
    mcpHubHead({
      title: "Flowstep MCP Server: Design UI From Claude Code or Cursor",
      description:
        "Connect Flowstep to any MCP client so your AI agent can generate and edit real UI screens. Setup guides for Claude Code, Cursor, Claude, Windsurf and Codex.",
      clients: MCP_CLIENTS,
      faqs: HUB_FAQS,
    }),
});
